<template>
  <el-container style="height: calc(100vh - 52px)">
    <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
      <div class="flex w-full flex-col md:flex-row">
        <!-- 検索部 -->
        <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
          <el-form :model="searchForm" label-width="auto" label-position="top">
            <div class="grid md:grid-cols-4 gap-4">
              <el-form-item class="no-margin" label="JANコード">
                <el-input v-model="searchForm.codeNumber" placeholder="JANコード">
                </el-input>
              </el-form-item>

              <el-form-item class="no-margin" label="商品名">
                <el-input v-model="searchForm.itemName" placeholder="商品名">
                </el-input>
              </el-form-item>

              <el-form-item class="no-margin" label="会社名">
                  <el-input v-model="searchForm.makerName" placeholder="会社名">
                  </el-input>
                </el-form-item>

              <div class="flex justify-end mt-7">
                <el-button class="hidden md:block w-24" type="info"
                  @click="getMngJancodes">検索</el-button>
              </div>
            </div>
          </el-form>
        </div>

        <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
          <div class="bg-white border-2 border-gray-400 rounded-md p-4">
            <el-form :model="searchForm" label-width="auto" label-position="top">
              <div class="grid gap-4">
                <el-form-item class="no-margin" label="JANコード">
                  <el-input v-model="searchForm.codeNumber" placeholder="JANコード">
                  </el-input>
                </el-form-item>

                <el-form-item class="no-margin" label="商品名">
                  <el-input v-model="searchForm.itemName" placeholder="商品名">
                  </el-input>
                </el-form-item>

                <div class="flex">
                  <el-form-item class="no-margin flex-grow" label="会社名">
                    <el-input v-model="searchForm.makerName" placeholder="会社名">
                    </el-input>
                  </el-form-item>

                  <div class="flex justify-end mt-7">
                    <el-button class="md:hidden ml-3" type="info" @click="getMngJancodes" circle>
                      <el-icon>
                        <span class="material-symbols-outlined">manage_search</span>
                      </el-icon>
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </el-drawer>

        <!-- 操作部 -->
        <div class="flex justify-end items-center md:flex-grow">
          <el-button class="custom-icon-btn md:hidden" type="info" 
              @click="drawer = true" circle>
              <span class="material-symbols-outlined">
                  manage_search
              </span>
          </el-button>

          <el-button class="custom-icon-btn md:hidden" type="info" @click="handleAddButton" circle>
            <span class="material-symbols-outlined">
              add
            </span>
          </el-button>
          <el-button class="hidden md:block w-24" type="info" @click="handleAddButton">新規登録</el-button>
        </div>
      </div>
    </el-header>

    <el-mian style="padding-bottom: 20px;">
      <!-- 手机CARD部 -->
      <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
        <div class="custom-title flex flex-col">
          <span>JANコードマスタ（JANコード　商品名）</span>
          <span class="ml-auto">
            <div class="flex items-center space-x-1">
              <span class="text-white">ソート:</span>
              <el-button 
                size="small" 
                @click="handleSort('codeNumber')"
                :class="['mobile-sort-btn', sortField === 'codeNumber' ? 'active' : '']">
                JANコード    
              </el-button>
              <el-button 
                    size="small" 
                    @click="handleSort('itemName')"
                    :class="['mobile-sort-btn', sortField === 'itemName' ? 'active' : '']">
                    商品名    
              </el-button>
              <span>アイテム数: {{ totalRecords }}</span>
            </div>
          </span>
        </div>

        <div style="height: calc(100vh - 227px); overflow-y: auto;">
          <el-card style="border: 1px solid #d1d5db; border-radius: 0px" 
            v-for="item in tableData" :key="item.codeNumber">
            <el-row align="middle">
              <el-col :span="2">
                  <el-button
                      class="w-8 h-16"
                      type="info" 
                      style="background-color: #b7b7b7;"
                      text
                      bg
                      @click="handleEdit(item)">
                      <span>詳<br>細</span>
                  </el-button>
              </el-col>

              <el-col :span="18" class="ml-2">
                <div>{{ item.codeNumber }}</div>
                <div>{{ item.itemName }}</div>
              </el-col>

              <el-col :span="2" class="ml-2" align="right">
                  <span class="material-symbols-outlined cursor-pointer"
                      @click="handleDelete(item)">
                      delete
                  </span>
              </el-col>
          </el-row>
          </el-card>
        </div>
      </div>

      <!-- WEB表格部 -->
      <div class="hidden md:block w-full">
        <el-table :data="tableData" height="calc(100vh - 260px)" v-loading="loading">
          <el-table-column label="JANコードマスタ" width="140" align="center">
            <template #default="scope">
              <el-button
                  class="w-12"
                  type="info"
                  style="background-color: #b7b7b7;"
                  text
                  bg
                  @click="handleEdit(scope.row)">
                  <span>詳細</span>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="codeNumber" label="JANコード" width="160">
            <template #header>
              <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('codeNumber')">
                <span>{{ getSortLabel('codeNumber') }}</span>
                <el-icon class="ml-1 flex-shrink-0">
                  <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'codeNumber' }">
                    {{ getSortIcon('codeNumber') }}
                  </span>
                </el-icon>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="商品名" min-width="400">
            <template #header>
              <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('itemName')">
                <span>{{ getSortLabel('itemName') }}</span>
                <el-icon class="ml-1 flex-shrink-0">
                  <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'itemName' }">
                    {{ getSortIcon('itemName') }}
                  </span>
                </el-icon>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="makerName" label="会社名" width="280">
            <template #header>
              <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('makerName')">
                <span>{{ getSortLabel('makerName') }}</span>
                <el-icon class="ml-1 flex-shrink-0">
                  <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'makerName' }">
                    {{ getSortIcon('makerName') }}
                  </span>
                </el-icon>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="削除" width="52" align="center">
            <template #default="scope">
              <span class="material-symbols-outlined cursor-pointer mt-2" @click="handleDelete(scope.row)">
                delete
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页部 -->
      <div class="flex w-full justify-end mt-4">
        <div class="hidden md:block mr-3">
          <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper" :total="totalRecords" @size-change="handleSizeChange"
            @current-change="handlePageChange" />
        </div>

        <div class="md:hidden">
          <el-pagination layout="prev, pager, next" :total="totalRecords" @current-change="handlePageChange" />
        </div>
      </div>
    </el-mian>
  </el-container>

  <!-- Add/Edit Dialog -->
  <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px" v-model="dialogFormVisible"
    :title="form.add_update === Operation.add ? '新規登録' : '詳細'" align-center>

    <div class="flex flex-col md:flex-row">
      <div class="w-full md:w-full">
        <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
          <el-form-item v-if="form.add_update === Operation.add" label="JANコード" prop="codeNumber" :error="errors.codeNumber">
            <el-input v-model="form.codeNumber" autocomplete="off" placeholder="JANコード" />
          </el-form-item>
          <el-form-item v-else label="コード番号" prop="codeNumber">
            <el-input v-model="form.codeNumber" disabled />
          </el-form-item>

          <el-form-item label="コードタイプ" prop="codeType">
            <el-input v-model="form.codeType" autocomplete="off" placeholder="コードタイプ" />
          </el-form-item>

          <el-form-item label="商品名" prop="itemName">
            <el-input v-model="form.itemName" autocomplete="off" placeholder="商品名" />
          </el-form-item>

          <el-form-item label="品番(型番)" prop="itemModel">
            <el-input v-model="form.itemModel" autocomplete="off" placeholder="型番" />
          </el-form-item>

          <el-form-item label="詳細ページURL" prop="itemUrl">
            <el-input v-model="form.itemUrl" autocomplete="off" placeholder="詳細ページURL" />
          </el-form-item>

          <el-form-item label="商品画像URL" prop="itemImageUrl">
            <el-input v-model="form.itemImageUrl" autocomplete="off" placeholder="画像URL" />
          </el-form-item>

          <el-form-item label="ブランド名" prop="brandName">
            <el-input v-model="form.brandName" autocomplete="off" placeholder="ブランド名" />
          </el-form-item>

          <el-form-item label="メーカー名" prop="makerName">
            <el-input v-model="form.makerName" autocomplete="off" placeholder="メーカー名" />
          </el-form-item>

          <el-form-item label="会社名(カナ)" prop="makerNameKana">
            <el-input v-model="form.makerNameKana" autocomplete="off" placeholder="メーカー" />
          </el-form-item>

          <el-form-item label="商品追加情報" prop="productDetail">
            <el-input v-model="form.productDetail" autocomplete="off" placeholder="商品詳細" />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false">キャンセル</el-button>
        <el-button type="primary" @click="submitForm">{{ form.add_update === 'add' ? '登録' : '更新' }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, nextTick } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Plus, Delete, Edit, Search } from '@element-plus/icons-vue';
import type { FormInstance, FormRules } from 'element-plus';
import axios, { AxiosResponse } from 'axios';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import BarcodeScanner from '@/components/common/BarcodeScanner.vue';
import router from '@/router';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { sortingUtil, SortConfig } from '@/components/common/SortingUtil';

// 操作类型枚举
enum Operation {
  add = 'add',
  update = 'update',
  unknow = 'unknow'
}

// JANコード情報インターフェース
interface JancodeInfo {
  add_update?: Operation;
  codeNumber: string;
  codeType: string;
  itemName: string;
  itemModel: string;
  itemUrl: string;
  itemImageUrl: string;
  brandName: string;
  makerName: string;
  makerNameKana: string;
  productDetail: string;
}

export default defineComponent({
  name: 'MngJancode',
  components: {
    BarcodeScanner,
    Plus,
    Delete,
    Edit,
    Search,
  },
  setup() {
    // 検索フォーム
    const searchForm = ref({
      codeNumber: '',
      itemName: '',
      makerName: ''
    });

    // テーブルデータ
    const allJancodes = ref<JancodeInfo[]>([]);
    const loading = ref<boolean>(true);
    const size = ref<string>('small');
    const background = ref<boolean>(true);

    // フォームデータ
    const form = ref<JancodeInfo>({
      add_update: Operation.unknow,
      codeNumber: '',
      itemName: '',
      makerNameKana: '',
      makerName: '',
      itemModel: '',
      brandName: '',
      codeType: '',
      itemUrl: '',
      itemImageUrl: '',
      productDetail: '',
    });

    const sortConfig: SortConfig = {
      codeNumber: {
        label: 'JANコード',
        mobileLabel: 'JANコード',
        type: 'string',
        defaultOrder: 'asc'
      },
      itemName: {
        label: '商品名',
        mobileLabel: '商品名',
        type: 'string',
        defaultOrder: 'asc'
      },
      makerName: {
        label: '会社名',
        mobileLabel: '会社名',
        type: 'string',
        defaultOrder: 'asc'
      },
    }

    const {
      paginatedData: tableData,
      totalRecords,
      currentPage,
      pageSize,
      handleSizeChange,
      handlePageChange,
      showMoreDataAlert,
      sortField,
      sortOrder,
      handleSort,
      getSortLabel,
      getSortIcon,
    } = sortingUtil(
      allJancodes,
      sortConfig,
    );

    const drawer = ref(false);

    const dialogFormVisible = ref(false);
    const formRef = ref<FormInstance>();
    const barcodeScannerRef = ref(null);

    const errors = ref({
      codeNumber: '',
    });

    // バリデーションルール
    const rules = ref<FormRules>({
      codeNumber: [
        { required: true, message: 'JANコードを入力してください', trigger: 'blur' },
        { min: 8, max: 13, message: 'JANコードは8〜13桁で入力してください', trigger: 'blur' }
      ],
      itemName: [
        { required: true, message: '商品名を入力してください', trigger: 'blur' }
      ],
    });

    // JANコード一覧を取得
    const getMngJancodes = async () => {
      drawer.value = false;
      loading.value = true;
      try {
        const params = {
          codeNumber: searchForm.value.codeNumber,
          itemName: searchForm.value.itemName,
          makerName: searchForm.value.makerName
        };

        const response = await axios.get('/api/jancodes/search', { params });

        if (response.status === ResponseStatus.SUCCESS && response.data.code === ErrorCode.OK) {
          const { data, hasMoreData } = response.data;
          allJancodes.value = data.data || [];
          showMoreDataAlert(hasMoreData || false);
        } else {
          ElMessage.error(getErrorMessage(PageType.JANCODE, response.data.code));
        }
      } catch (error) {
        ElMessage.error(getErrorMessage(PageType.JANCODE, ErrorCode.GET_LIST_FAILED));
      } finally {
        loading.value = false;
      }
    };

    // スキャンされたコードを処理
    const handleScannedCode = (code: string) => {
      if (form.value.add_update === Operation.add) {
        form.value.codeNumber = code;
      }
    };

    // 追加ボタンハンドラ
    const handleAddButton = () => {
      form.value = {
        add_update: Operation.add,
        codeNumber: '',
        itemName: '',
        makerNameKana: '',
        makerName: '',
        itemModel: '',
        brandName: '',
        codeType: '',
        itemUrl: '',
        itemImageUrl: '',
        productDetail: '',
      };
      dialogFormVisible.value = true;
      nextTick(() => {
        formRef.value?.resetFields();
      });
    };

    // 詳細ボタンハンドラ
    const handleEdit = (row: JancodeInfo) => {
      form.value = {
        add_update: Operation.update,
        ...row
      };
      dialogFormVisible.value = true;
    };

    // 削除ボタンハンドラ
    const handleDelete = (row: JancodeInfo) => {
      ElMessageBox.confirm('このJANコードを削除しますか？', '確認', {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning',
      }).then(async () => {
        loading.value = true;
        try {
          const response = await axios.delete(`/api/jancodes/${row.codeNumber}`);

          if (response.status === ResponseStatus.SUCCESS && response.data.code === ErrorCode.OK) {
            ElMessage.success('JANコードが削除されました');
            getMngJancodes();
          } else {
            ElMessage.error(getErrorMessage(PageType.JANCODE, response.data.code));
          }
        } catch (error) {
          ElMessage.error(getErrorMessage(PageType.JANCODE, ErrorCode.DELETE_FAILED));
        } finally {
          loading.value = false;
        }
      }).catch(() => {
        // キャンセルされた場合は何もしない
      });
    };

    // フォーム送信
    const submitForm = async () => {
      if (!formRef.value) return;

      await formRef.value.validate(async (valid: boolean) => {
        if (valid) {
          try {
            const jancodeData = {
              codeNumber: form.value.codeNumber,
              itemName: form.value.itemName,
              makerNameKana: form.value.makerNameKana,
              makerName: form.value.makerName,
              itemModel: form.value.itemModel,
              brandName: form.value.brandName,
              codeType: form.value.codeType,
              itemUrl: form.value.itemUrl,
              itemImageUrl: form.value.itemImageUrl,
              productDetail: form.value.productDetail,
            };

            let response;
            if (form.value.add_update === Operation.add) {
              response = await axios.post('/api/jancodes', jancodeData);
            } else {
              response = await axios.put(`/api/jancodes/${form.value.codeNumber}`, jancodeData);
            }

            if (response.status === ResponseStatus.SUCCESS) {
              if (response.data.code === ErrorCode.OK) {
                ElMessage.success(form.value.add_update === Operation.add ? 'JANコードが追加されました' : 'JANコードが更新されました');
                dialogFormVisible.value = false;
                getMngJancodes();
              } else if (response.data.code === ErrorCode.ALREADY_EXIST) {
                errors.value.codeNumber = getErrorMessage(PageType.JANCODE, response.data.code);
                // ElMessage.error(getErrorMessage(PageType.JANCODE, response.data.code));
                // Keep dialog open so user can modify the code
              } else {
                ElMessage.error(getErrorMessage(PageType.JANCODE, response.data.code));
              }
            } else {
              ElMessage.error(getErrorMessage(PageType.JANCODE, response.data.code));
            }
          } catch (error) {
            ElMessage.error(getErrorMessage(PageType.JANCODE, ErrorCode.UPDATE_FAILED));
          }
        } else {
          ElMessage.warning('入力内容を確認してください');
        }
      });
    };

    onMounted(() => {
      getMngJancodes();
    });

    return {
      searchForm,
      tableData,
      loading,
      currentPage,
      pageSize,
      totalRecords,
      size,
      background,
      form,
      formRef,
      dialogFormVisible,
      rules,
      getMngJancodes,
      handleScannedCode,
      handleAddButton,
      handleEdit,
      handleDelete,
      submitForm,
      handleSizeChange,
      handlePageChange,
      barcodeScannerRef,
      Operation,
      // Icons
      Plus,
      Delete,
      Edit,
      Search,
      drawer,
      errors,
      sortField,
      sortOrder,
      handleSort,
      getSortLabel,
      getSortIcon,
    };
  }
});
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.barcode-scanner-container {
  margin-top: 1rem;
  width: 100%;
}

.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>